"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormButton from "./webflow_modules/Form/components/FormButton";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSelect from "./webflow_modules/Form/components/FormSelect";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormTextarea from "./webflow_modules/Form/components/FormTextarea";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";

export function ContactFormHomePage({
  communitySelectRuntimeProp = {},
  formEventRuntimeProps = {},
  formRuntimeProps = {},
}) {
  return (
    <FormWrapper
      className={"contact_form_component"}
      {...formEventRuntimeProps}
    >
      <FormForm
        className={"contact_form"}
        data-name={"SRGLiving - Contact Form"}
        id={"wf-form-SRGLiving---Contact-Form"}
        method={"get"}
        name={"wf-form-SRGLiving---Contact-Form"}
        {...formRuntimeProps}
      >
        <Block className={"div-block-36"} tag={"div"}>
          <Block className={"form_field-wrapper"} tag={"div"}>
            <FormTextInput
              aria-label={"What is your first and last name?"}
              autoFocus={false}
              className={"form_input"}
              data-name={"Name"}
              disabled={false}
              id={"Name-4"}
              maxLength={256}
              name={"Name"}
              placeholder={"Name"}
              required={true}
              type={"text"}
            />
          </Block>
          <Block className={"form_field-wrapper"} tag={"div"}>
            <FormTextInput
              autoFocus={false}
              className={"form_input"}
              data-name={"Email"}
              disabled={false}
              id={"Email"}
              maxLength={256}
              name={"Email"}
              placeholder={"Email"}
              required={true}
              type={"email"}
            />
          </Block>
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormSelect
            aria-label={"What kind of question do you have?"}
            className={"form_input"}
            data-name={"Feedback"}
            id={"Feedback"}
            multiple={false}
            name={"Feedback"}
            options={[
              {
                t: "I have a question/comment about a community",
                v: "I have a question/comment about a community",
              },
              {
                t: "I have a question/comment for Sares-Regis",
                v: "I have a question/comment for Sares-Regis",
              },
              {
                t: "I'm a resident with a question",
                v: "I'm a resident with a question",
              },
            ]}
            required={true}
          />
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormSelect
            aria-label={"What community is this related to?"}
            className={"form_input"}
            data-name={"Community"}
            id={"Community"}
            multiple={false}
            name={"Community"}
            options={[
              {
                t: "Community",
                v: "",
              },
              {
                t: "First choice",
                v: "First",
              },
              {
                t: "Second choice",
                v: "Second",
              },
              {
                t: "Third choice",
                v: "Third",
              },
            ]}
            required={false}
            {...communitySelectRuntimeProp}
          />
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormTextarea
            autoFocus={false}
            className={"form_input is-text-area"}
            data-name={"Message"}
            id={"Message"}
            maxLength={5000}
            name={"Message"}
            placeholder={"Message"}
            required={true}
          />
        </Block>
        <Block
          className={"margin-top margin-small"}
          id={"w-node-_72ea2081-fc0a-f3bd-eb7f-e4395dc407aa-5dc4079d"}
          tag={"div"}
        >
          <FormButton
            className={"button is-secondary"}
            data-wait={"Please wait..."}
            id={"w-node-_72ea2081-fc0a-f3bd-eb7f-e4395dc407ab-5dc4079d"}
            type={"submit"}
            value={"Submit"}
          />
        </Block>
        <HtmlEmbed
          content={
            '<input type="hidden" name="form-name" value="contact">\n<input type="hidden" name="bot-field" value="">'
          }
          id={"w-node-_49f71086-cee0-59cd-2ef5-598c1d13cc01-5dc4079d"}
        />
      </FormForm>
      <FormSuccessMessage className={"success-message hide"} />
      <FormErrorMessage className={"error-message"} />
    </FormWrapper>
  );
}
